import apiClient from './client';

export const customersApi = {
  // Core customers
  getAll: (params) => apiClient.get('/customers', { params }),
  getById: (id) => apiClient.get(`/customers/${id}`),
  create: (data) => apiClient.post('/customers', data),
  update: (id, data) => apiClient.put(`/customers/${id}`, data),
  delete: (id) => apiClient.delete(`/customers/${id}`),

  // Import / Export
  import: (formData) =>
    apiClient.post('/customers/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  export: (params) => apiClient.get('/customers/export', { params, responseType: 'blob' }),

  // Details / Information
  getDetails: (id) => apiClient.get(`/customers/${id}/details`),
  getInformation: (id) => apiClient.get(`/customers/${id}/information`),
  getConversation: (customerId) =>
    apiClient.get('/customer/conversation', { params: { id: customerId } }),
  getAllConversations: () => apiClient.get('/customers/conversation'),

  // Enquiries
  getEnquiries: (params) => apiClient.get('/customers/enquiries', { params }),
  createEnquiry: (data) => apiClient.post('/customers/enquiries', data),
  getEnquiryById: (id) => apiClient.get(`/customers/enquiries/${id}`),
  getAllEnquiries: (params) => apiClient.get('/customers/all-enquiries', { params }),
  updateEnquiry: (id, data) => apiClient.put(`/customers/enquiries/${id}`, data),

  // Block / Unblock
  block: (id) => apiClient.post(`/customers/${id}/block`),
  unblock: (id) => apiClient.post(`/customers/${id}/unblock`),

  // Tags (uid-based tag master)
  getTags: () => apiClient.get('/customers/tags'),
  createTag: (data) => apiClient.post('/customers/tags', data),
  assignTagsToCustomers: (data) => apiClient.post('/customers/tags/assign', data),
  unassignTagsFromCustomers: (data) => apiClient.post('/customers/tags/unassign', data),
  updateTag: (tagId, data) => apiClient.put(`/customers/tags/${tagId}`, data),
  deleteTag: (tagId) => apiClient.delete(`/customers/tags/${tagId}`),

  // Tags (assign to customer)
  addTag: (id, tag) => apiClient.post(`/customers/${id}/tags`, { tag }),
  removeTag: (id, tag) => apiClient.delete(`/customers/${id}/tags/${tag}`),
};

export default customersApi;
